<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="products">

            <div v-for="product in products.slice(0, 5)" style="display: flex;font-size: 12px;border-bottom:1px solid #eee;padding: 5px 0;align-items: center;width: 100%;" v-bind:style="">
                <div style="padding: 0px 10px;"><img :src="product.picture + '/fit/200x200'" width="50"/></div>
                <div style="padding-right: 20px;padding-left: 10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><strong style="font-weight: 800;font-size: 1.1em; margin-bottom: 0.3em; display: block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ product.name }}</strong><p style="text-transform: uppercase;">{{ product.sku }}</p></div>
                <div style="margin-left: auto;font-size: 18px; width: 80px; text-align: right;padding: 0px 10px;">
                    <strong style="font-weight: 800;display: block;">{{ product.count|formatNumber('0,0') }}</strong>
                    <span class="compare increase" v-if="product.count_last < product.count">+ {{ (product.count - product.count_last)|formatNumber('0,0') }}</span>
                    <span class="compare decrease" v-if="product.count_last > product.count">- {{ (product.count_last - product.count)|formatNumber('0,0') }}</span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>

    import OrderService from './OrderService.js';

    export default {
        name: 'Widget',
        props: ['title','period','className'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                ],
                loaded: false,
                products: null
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id

            this.filterByPeriod(this.period);

        },
        methods: {
            filterByPeriod: function(period)
            {

                this.loaded = false;

                this.period = period

                OrderService.getStatsBestsellers( this.period ).then((response) => {
                    this.products = response.data
                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/order/OrderBestsellersWidget.vue